import { type SimpleLoad, useApiLogisticsV1LoadsList } from 'api';
import { useState } from 'react';

import {
  MultiAutocompleteField,
  type MultiAutocompleteFieldProps,
} from '../MultiAutocompleteField/MultiAutocompleteField';

export type MultiLoadAutocompleteProps = Omit<
  MultiAutocompleteFieldProps<SimpleLoad>,
  'options' | 'getOptionLabel' | 'isOptionEqualToValue' | 'valueField'
> & {
  assignableToShipment?: string;
  hasShipment?: boolean;
  salesOrderSlug?: string;
};

export const MultiLoadAutocomplete = ({
  assignableToShipment,
  hasShipment,
  salesOrderSlug,
  ...rest
}: MultiLoadAutocompleteProps) => {
  const [query, setQuery] = useState('');

  const { data, isLoading } = useApiLogisticsV1LoadsList({
    assignable_to_shipment: assignableToShipment,
    has_shipment: hasShipment,
    page_size: 50,
    sales_order_slug: salesOrderSlug,
    search: query,
  });

  return (
    <MultiAutocompleteField<SimpleLoad>
      options={data?.results || []}
      loading={isLoading}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      valueField="id"
      filterOptions={(options, state) => {
        setQuery(state.inputValue);
        return options;
      }}
      {...rest}
    />
  );
};
